import HTTP from '../libs/HTTP';

//query接口请求参数
export interface FileQueryParam {
    id?: number;
    name?: string;
    format?: String;
}

export interface FileListRequest {
    fileQueryParam: FileQueryParam;
    pageNo: number;
    pageSize: number;
}

//query接口返回
export interface ICompanyInfoList {
    records: IFileInfo[];
    total: number;
    size: number;
    current: number;
    pages: number;
}
export interface IFileInfo {
    id: number;
    name: string;
    originName: string;
    url: string;
    format: string;
    size?: number;
    time?: number;
    dragForbidden: boolean;
}

//Add File接口请求参数
export interface AddFileParam {
    name: string;
    originName: string;
    url: string;
    format: string;
    size?: number;
    time?: number;
    dragForbidden: boolean;
}

//Edit File接口请求参数
export interface EditFileParam {
    id: number;
    name?: string;
    originName?: string;
    url?: string;
    format?: string;
    size?: number;
    time?: number;
    dragForbidden?: boolean;
}


class FileService extends HTTP {

    //根据查询条件查询文件信息
    async getFileListInfo(request: FileListRequest) {
        const response = await this.post('/file/getFileByFilter', request.fileQueryParam, {
            params: {
                pageNo: request.pageNo,
                pageSize: request.pageSize,
            },
        });
        if (response) {
            return response.data;
        }
    }

    //根据id查询文件信息
    async getFileById(fileId: number) {
        const response = await this.get(`/file/getFileById/${fileId}`);
        if (response) {
            return response.data;
        }
    }

    //根据文件名查询文件信息
    async getFileByName(name: string) {
        const response = await this.get(`/file/getFileById/${name}`);
        if (response) {
            return response.data;
        }
    }

    //添加文件信息
    async addFile(request: AddFileParam) {
        const response = await this.post('/file/addFile', request, {
            params: {
                name: request.name,
                originName: request.originName,
                url: request.originName,
                format: request.format,
                size: request.size,
                time: request.time,
                dragForbidden: request.dragForbidden,
            },
        });
        if (response) {
            return response.data;
        }
    }

    //更新文件信息
    async editFile(request: EditFileParam) {
        const response = await this.put(`/file/addFile/${request.id}`, request, {
            params: {
                name: request.name,
                originName: request.originName,
                url: request.originName,
                format: request.format,
                size: request.size,
                time: request.time,
                dragForbidden: request.dragForbidden,
            },
        });
        if (response) {
            return response.data;
        }
    }
}

export default new FileService();
